import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import MarathonsContent from '../../../components/Pages/Marathons/Telegrams';

const { displayName } = config;

export default function MarathonTelegrams(): React.ReactNode | null {
  document.title = `${displayName}: Редактировать ссылки на Телеграм-каналы`;

  return (
    <Layout>
      <MarathonsContent />
    </Layout>
  );
}
